import { makeObservable, observable, action } from 'mobx';
import { createContext } from 'react';

class ThemeStore {
  typography = {};

  constructor() {
    makeObservable(this, {
      typography: observable,
      setTypography: action,
    });
  }

  setTypography(newTypography) {
    this.typography = newTypography || {};
  }
}

const themeStore = new ThemeStore();
export default themeStore;

export const ThemeContext = createContext();
